/**
 * Tema tampilan baru: ikuti perangkat, terang, atau gelap (ADR-116).
 *
 * Bawaannya mengikuti perangkat, seperti sejak ADR-094 no. 8. Pilihan lain ditempel sebagai
 * `data-tema` di `<html>`, dan `gaya/baru.css` yang menerjemahkannya jadi token warna. Tidak
 * ada `data-tema` berarti mengikuti perangkat: penanda yang tidak ada tidak bisa basi.
 *
 * Disimpan di PERAMBAN ini, bukan di akun: orang yang sama sering memakai laptop terang di
 * kantor dan HP gelap di malam hari. Penyimpanan yang tidak bisa dipakai (mode privat)
 * berarti pilihannya berlaku sampai halamannya ditutup.
 *
 * Atributnya dipasang `app/Akar.jsx` bersama `data-ui`, sebelum gambar pertama, dan hanya
 * untuk tampilan baru. Tampilan lama tidak diubah.
 */
import { useCallback, useState } from 'react'

export const KUNCI_TEMA = 'smova.tema'
export const TEMA = ['perangkat', 'terang', 'gelap']
export const TEMA_BAWAAN = 'perangkat'

export function bacaTema() {
  try {
    const nilai = localStorage.getItem(KUNCI_TEMA)
    return TEMA.includes(nilai) ? nilai : TEMA_BAWAAN
  } catch {
    return TEMA_BAWAAN
  }
}

export function pasangTema(tema, akar = document.documentElement) {
  if (tema === 'terang' || tema === 'gelap') akar.dataset.tema = tema
  else delete akar.dataset.tema
}

function simpanTema(tema) {
  try {
    if (tema === TEMA_BAWAAN) localStorage.removeItem(KUNCI_TEMA)
    else localStorage.setItem(KUNCI_TEMA, tema)
  } catch {
    // Penyimpanan ditolak peramban: pilihannya tetap berlaku di halaman ini.
  }
}

/** `[tema, gantiTema]`. Mengganti langsung terlihat dan langsung tersimpan. */
export function useTema() {
  const [tema, setTema] = useState(bacaTema)
  const gantiTema = useCallback((baru) => {
    if (!TEMA.includes(baru)) return
    simpanTema(baru)
    pasangTema(baru)
    setTema(baru)
  }, [])
  return [tema, gantiTema]
}
